module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/zoom-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/zoom-icon.svg
// module id = 388
// module chunks = 0